import React, { Suspense, Fragment ,useState,useEffect} from 'react';
// import { TrendingDown, TrendingUp } from 'react-feather';
import { Card, CardBody, Table } from 'reactstrap';
// import { H5 } from '../../../AbstractElements';
// import { AllCampaignsTitle, DailyDropdown } from '../../../Constant';
import { PaymentTable } from '../../../../../Data/Payment';
import Loader from '../../../../../Layout/Loader';
import { Navigator } from '../../../../../Data/Table/Defaultdata';
import DataTable from 'react-data-table-component';
import { useLocation } from 'react-router';
import { AppointmentPaymentList } from '../../../../../apiController';
// import DropdownCommon from '../../Common/Dropdown'; 

const Payment = ({permission}) => {


  const location = useLocation()

  const {data} = location.state || {}

  const [patientPaymentList, setPatientPaymentList] = useState([])

  
  
  
//   const treatmenttabledata = 
//   patientPaymentList.map(((row, ind)=>{

//     const patientTreatment = JSON.parse(row.payment.map((d)=> d.services.map((trt)=> trt.patient_treatment)));

//     console.log(patientTreatment)

    
//    return {
//         ind: ind+1,
//         id: row.id,
//         date:row.date ,
//         type: patientTreatment.type === "tooth" ? (
//           <p>{patientTreatment.tooth}</p>
//         ) : 
//           patientTreatment.type,
//         diagnosis: patientTreatment.problem ? patientTreatment.problem.name : "-",
//         method: patientTreatment.itemsPr
//         ? patientTreatment.itemsPr.map((t) => t.mname).join(", ")
//         : "-",
//         total: row.payment.map((d)=> d.total),
//         action: <span>{
//         <Navigator to={`${process.env.PUBLIC_URL}/checkout/:layout`} params={{ rowData: row ,data: data, btn: "pay"}}/>}
//       </span>

//     }
//   }
  
//   )
// )



const tableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: false,
    },
    {
        name: 'Date',
        selector: row => row['date'],
        sortable: true,
        center: false,
    },
    {
        name: 'Type',
        selector: row => row['type'],
        sortable: true,
        center: true,
    },
    {
      name: 'Diagnosis',
      selector: row => `${row.diagnosis}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Treatment Done',
      selector: row => `${row.method}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Total Price',
      selector: row => `${row.total}`,
      sortable: true,
      center: true,
  },
    {
        name: 'Action',
        selector: row => row['action'],
        sortable: false,
        center: true,
    },
];

const patientId = data.id;
useEffect(() => {
  // console.log(data)
  // console.log(data.id)
  fetchPatientAppointmentPaymentList(patientId);
}, []);

const fetchPatientAppointmentPaymentList = async (id) => {
  const response = await AppointmentPaymentList({ patient_id: id });
  if (response.status === true) {
    const patientPaymentData = response.data;
    console.log(patientPaymentData);
    setPatientPaymentList(patientPaymentData);
  }
};
  return (
    <Suspense fallback={<Loader/>}>
       <Fragment >
        {/* {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            } */}
        {/* <DataTable
        className='mt-5'
                data={treatmenttabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                // selectableRows
                // onSelectedRowsChange={handleRowSelected}
                // clearSelectedRows={toggleDelet}
                responsive
            /> */}
            </Fragment>
    <Card className='mt-3'>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
          <Table>
            <thead>
              <tr>
                {tableColumns.map((item, i) => (
                  <th key={i} className='f-light text-center'>
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {patientPaymentList.map((item, i) => (
                <tr key={i} className='text-center'>
                  <td>{i+1}</td>
                  <td className='text-center'>
                    {item.date}
                  </td>
                  < td >
                  {
                    item.payment.map((t) => (t.services.map((p,i) => (
                      <span key={i}>{JSON.parse(p.patient_treatment).type === 'tooth' ? (
                        <span>{JSON.parse(p.patient_treatment).tooth}<br /></span>
                      ) : (
                        <span>general<br /></span>
                      )}
                      </span>
                    )

                    )))
                  }
                </td>
                  <td className='tdata'>{item.payment.map((t,i) => (t.services.map((p) => (
                  <span key={i}>{JSON.parse(p.patient_treatment).problem.name}<br /></span>
                )))
                )}</td>
                   <td >{item.payment.map((t) => t.services.map((p,i) => (
                  <span key={i}>{JSON.parse(p.patient_treatment)?.itemsPr?.map((t) => <tr>{t.mname}</tr>)} <br /></span>
                ))
                )}</td>
                  <td className='text-center'>{item.payment.map((d)=> d.total)}</td>
                  <td><span>{
        <Navigator to={`${process.env.PUBLIC_URL}/checkout/:layout`} params={{ rowData: item ,data: data, permission: permission, btn: "Invoice"}}/>}
      </span></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
    </Suspense>
  );
};

export default Payment;
